import type { Amount, Price } from "$apis/parkito2/types.gen.ts";

export default class PriceModel implements Price {
  constructor(private _price: Price) {}

  get sub(): Amount {
    return this._price.sub;
  }

  get vat(): Amount {
    return this._price.vat;
  }

  getWithVat(): number {
    return this.sub + this.vat;
  }

  format(withVat: boolean = true): string {
    const total = (this.sub + (withVat ? this.vat : 0)) / 100;
    const units = Math.floor(total);
    const subUnits = (total * 100) % 100;

    const subUnitsString = subUnits === 0
      ? undefined
      : subUnits < 10
      ? `0${subUnits}`
      : subUnits.toString();

    return units + (subUnitsString ? `,${subUnitsString}` : "");
  }

  add(rhs: PriceModel): PriceModel {
    return new PriceModel({
      sub: this.sub + rhs.sub,
      vat: this.vat + rhs.vat,
    });
  }

  isVatFree() {
    return this.vat === 0;
  }
}
